<template>
  <el-dialog
    :title="$t('deleteAffiliateCommission.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align: center">
      <p>{{ $t('deleteAffiliateCommission.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('deleteAffiliateCommission.cancel') }}</el-button>
      <el-button type="primary" @click="deleteAffiliateCommission">{{ $t('deleteAffiliateCommission.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteAffiliateCommission } from '@/api/affiliate/affiliateCommissionApi'

export default {
  name: 'DeleteAffiliateCommission',
  data() {
    return {
      dialogVisible: false,
      deleteData: {}
    }
  },
  methods: {
    open(data) {
      this.deleteData = data
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteData = {}
    },
    async deleteAffiliateCommission() {
      try {
        this.deleteData.shopId = getShopId()
        await deleteAffiliateCommission(this.deleteData)
        this.$emit('refresh')
        this.closeDialog()
        this.$message.success(this.$t('deleteAffiliateCommission.deleteSuccess'))
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(this.$t('deleteAffiliateCommission.deleteFailed'))
      }
    }
  }
}
</script>